import React, { useEffect, useState } from 'react';
import {
  Button,
  Col,
  Form,
  Input,
  Modal,
  Radio,
  Row,
  Select,
  Table,
  Tabs,
} from 'antd';
import { MdAddCircle } from 'react-icons/md';
import _, { filter } from 'lodash';
import { ExclamationCircleOutlined, SettingOutlined } from '@ant-design/icons';
import consts, { TIME_OF_DEBOUNCE } from '../consts';
import utils from '../common/utils';
import DisplayControl from './DisplayControl';

import Loadingsvg from './common/Loadingsvg';

const PERMISSION_LINK_SCREEN_MIGRATE_BTC = '/admin/migrate-btc';
const PERMISSION_LINK_SCREEN_MIGRATE_ETH = '/admin/migrate-eth';
const PERMISSION_LINK_SCREEN_MIGRATE_ERC20 = '/admin/migrate-erc20';
const PERMISSION_LINK_SCREEN_MIGRATE_TOMO = '/admin/migrate-tomo';
const PERMISSION_LINK_SCREEN_MIGRATE_TOMO_ERC20 = '/admin/migrate-tomo-erc20';
const PERMISSION_LINK_SCREEN_ADD_ADMIN_WALLET = '/admin/admin-wallet';
const PERMISSION_LINK_SCREEN_SET_ADMIN_TRANSFER = '/admin/admin-transfer';
const { confirm } = Modal;

const { TabPane } = Tabs;

const tab = {
  ETH: '1',
  TOMO: '2',
};

const balanceColumn = [
  {
    title: 'Ký hiệu',
    dataIndex: 'symbol',
    key: 'symbol',
  },
  {
    title: 'Mã ERC20',
    dataIndex: 'contract',
    key: 'contract',
  },
  {
    title: 'Tên đồng',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: 'Số dư',
    dataIndex: 'balance',
    key: 'balance',
  },
];

const columns = [
  {
    title: 'Mã người dùng',
    dataIndex: 'uid',
    key: 'uid',
  },
  {
    title: 'Địa chỉ',
    dataIndex: 'address',
    key: 'address',
  },
];

const columnsErrERC20 = [
  {
    title: 'Địa chỉ',
    dataIndex: 'address',
    key: 'address',
  },
  {
    title: 'Phí',
    dataIndex: 'fee',
    key: 'fee',
  },
];

function AdminWalletBalance(props) {
  const [visible, setVisible] = useState(false);
  const [transferVisible, setTransferVisible] = useState(false);
  const [permissionLinkMigrate, setPermissionLinkMigrate] = useState({
    permission_link: '/admin/migrate-btc',
  });
  const [paramsTransfer, setParamsTransfer] = useState({
    coin: 'BTC',
    address: '',
    gas: 'FAST',
  });
  const [params, setParams] = useState({
    label: '',
    private_key: '',
    pubkey: '',
  });
  const [mapAddressArr, setMapAddressArr] = useState({});
  const [mapLoading, setMapLoading] = useState({});
  const [mapErrErc20Arr, setMapErrErc20Arr] = useState({});
  const [mapLoadingErrErc20, setMapLoadingErrErc20] = useState({});
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);
  const [token, setToken] = useState(tab.ETH);

  const showModalBan = (item) => {
    confirm({
      title:
        'Bạn có chắc chắn muốn đặt người dùng này là người chung chuyển không ?',
      icon: <ExclamationCircleOutlined />,
      // content: 'Some descriptions',
      okText: 'Đặt làm người chung chuyển',
      okType: 'danger',
      cancelText: 'Không',
      onOk() {
        props.setAdminTransfer(item);
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  };

  const columns = [
    {
      title: 'Mã người dùng',
      dataIndex: 'uid',
      key: 'uid',
    },
    {
      title: 'Địa chỉ',
      dataIndex: 'address',
      key: 'address',
    },
    {
      title: 'Hành động',
      key: 'action',
      render: (item) => (
        <div className="block">
          {item.is_dedicate ? (
            <span className="bold">Đang là người chung chuyển</span>
          ) : (
            <DisplayControl permission_link_screen={consts.AUTH.MANAGER__ADMIN_TRANSFER__UID__ADDRESS} action={consts.CONTROLS.PUT}>
              <SettingOutlined
                className="styled-icon"
                onClick={() => showModalBan(item)}
              />
            </DisplayControl>
          )}
        </div>
      ),
    },
  ];

  const showModalAdd = () => {
    setVisible(true);
  };

  const showModalTransfer = () => {
    setTransferVisible(true);
  };

  const handleOk = () => {
    setVisible(false);
    props.addAdminAction(params);
  };

  const handleTransfer = _.debounce(() => {
    if (paramsTransfer.coin === consts.SYMBOL_BTC) {
      props.migrateBTCAction(paramsTransfer, callback);
    } else if (paramsTransfer.coin === consts.SYMBOL_ETH) {
      props.migrateETHAction(paramsTransfer, callback);
    } else if (paramsTransfer.coin === consts.SYMBOL_ERC20) {
      props.migrateERC20Action(paramsTransfer, callback);
    } else {
      utils.showNotification('Đồng sai định dạng');
    }
  }, TIME_OF_DEBOUNCE);

  const handleCancelModelTranfer = () => {
    if (paramsTransfer.address === '') utils.showNotification('Thông báo!', 'Vui lòng nhập địa chỉ!', 'error');
    else {
      setIsLoadingSubmit(true);
      handleTransfer();
    }
  };
  const callback = () => {
    setIsLoadingSubmit(false);
    setTransferVisible(false);
  };
  const handleCloseTransfer = () => {
    setTransferVisible(false);
  };

  const handleCancel = () => {
    setVisible(false);
  };

  const handleChangeInput = (event) => {
    event.preventDefault();
    const { target } = event;
    const { name } = target;
    if (target) {
      setParams({
        ...params,
        [name]: target.value,
      });
    }
  };

  const handleOnChangeCoin = (coin) => {
    switch (coin) {
      case consts.SYMBOL_BTC:
        setPermissionLinkMigrate({
          permission_link: PERMISSION_LINK_SCREEN_MIGRATE_BTC,
        });
        break;
      case consts.SYMBOL_ETH:
        setPermissionLinkMigrate({
          permission_link: PERMISSION_LINK_SCREEN_MIGRATE_ETH,
        });
        break;
      case consts.SYMBOL_ERC20:
        setPermissionLinkMigrate({
          permission_link: PERMISSION_LINK_SCREEN_MIGRATE_ERC20,
        });
        break;
      case consts.SYMBOL_TOMO:
        setPermissionLinkMigrate({
          permission_link: PERMISSION_LINK_SCREEN_MIGRATE_TOMO,
        });
        break;
      case consts.SYMBOL_TOMO_ERC20:
        setPermissionLinkMigrate({
          permission_link: PERMISSION_LINK_SCREEN_MIGRATE_TOMO_ERC20,
        });
        break;
      default:
        setPermissionLinkMigrate({
          permission_link: '',
        });
        break;
    }
    setParamsTransfer({ ...paramsTransfer, coin });
  };

  const handleChangeInputTransfer = (event) => {
    const { target } = event;
    const { name } = target;
    if (target) {
      setParamsTransfer({
        ...paramsTransfer,
        [name]: target.value,
      });
    }
  };

  const onChangeGas = ({ target }) => {
    setParamsTransfer({
      ...paramsTransfer,
      gas: target.value,
    });
  };

  const onTabChange = (value) => {
    setToken(value);
    switch (value) {
      case tab.ETH: {
        props.fetchAllErrERC20Action({
          pos: 0,
          count: 300,
        });
        break;
      }
      case tab.TOMO: {
        props.fetchAllErrTomoERC20Action({
          pos: 0,
          count: 300,
        });
        break;
      }
      default: {
      }
    }
  };

  const onFixEcr20Error = () => {
    switch (token) {
      case tab.ETH: {
        props.fixErrERC20Action();
        break;
      }
      case tab.TOMO: {
        props.fixErrTomoERC20Action();
        break;
      }
      default: {
      }
    }
  };

  useEffect(() => {
    props.fetchAdminWalletAction();
    props.fetchAllErrERC20Action({
      pos: 0,
      count: 300,
    });
  }, []);

  return (
    <div className="p-medium">
      <div className="input-search d-flex space-between align-items">
        <div className="fz-32">Số dư ví admin</div>
        <div className="d-flex direct-row">
          <Button className="d-flex mr-medium" onClick={showModalTransfer}>
            <span style={{ marginLeft: 4 }}>Chuyển tới địa chỉ</span>
          </Button>
          <DisplayControl
            permission_link_screen={PERMISSION_LINK_SCREEN_ADD_ADMIN_WALLET}
            action="POST"
          >
            <Button className="d-flex" onClick={showModalAdd}>
              <MdAddCircle size="20" className="styled-icon" />
              <span style={{ marginLeft: 4 }}> Thêm ví admin </span>
            </Button>
          </DisplayControl>
        </div>
      </div>
      <Table
        dataSource={props.adminWallets || []}
        columns={columns}
        expandable={{
          expandedRowRender: (value) => {
            const dataSource = Object.values(mapAddressArr[value.address] || {}) || [];
            return (
              <Table
                dataSource={filter(dataSource, (item) => item.symbol !== '')}
                columns={balanceColumn}
                loading={mapLoading[value.address]}
                pagination={{
                  hideOnSinglePage: true,
                  responsive: true,
                }}
              />
            );
          },
          // rowExpandable: (value) => value.name !== 'Not Expandable',
          onExpand: (isExpand, { address }) => {
            if (isExpand) {
              setMapLoading({
                ...mapLoading,
                [address]: true,
              });
              props.fetchAdminBalancesAction({ address }, (balances) => {
                setMapLoading({
                  ...mapLoading,
                  [address]: false,
                });
                setMapAddressArr({
                  ...mapAddressArr,
                  [address]: balances,
                });
              });
            }
          },
        }}
      />

      <div className="fz-32">Danh sách địa chỉ có số dư ERC20 thiếu phí</div>
      <div>
        <div className="d-flex direct-row jtf-end mb-medium">
          <DisplayControl permission_link_screen={[{ permisson: consts.AUTH.MANAGER__FIX_ERR_ERC20, action: consts.CONTROLS.POST }, { permisson: consts.AUTH.MANAGER__FIX_ERR_TOMO_ERC20, action: consts.CONTROLS.POST }]}>
            <Button className="" onClick={onFixEcr20Error}>
              <span style={{ marginLeft: 4 }}> Chuyển phí </span>
            </Button>
          </DisplayControl>
        </div>
      </div>
      <DisplayControl permission_link_screen={[{ permission: consts.AUTH.MANAGER__ERR_ERC20, action: consts.CONTROLS.GET }, { permisson: consts.AUTH.MANAGER__ERR_TOMO_ERC20, action: consts.CONTROLS.GET }]}>
        <Tabs
          onChange={onTabChange}
          defaultValue={tab.ETH}
        >
          <TabPane tab="ETH" key={tab.ETH} />
          <TabPane tab="TOMO" key={tab.TOMO} />
        </Tabs>
      </DisplayControl>
      <Table
        dataSource={props.errERC20s || []}
        columns={columnsErrERC20}
        expandable={{
          expandedRowRender: (value) => {
            const dataSource = Object.values(mapErrErc20Arr[value.address] || {}) || [];
            return (
              <Table
                dataSource={filter(dataSource, (item) => item.symbol !== '')}
                columns={balanceColumn}
                loading={mapLoadingErrErc20[value.address]}
                pagination={{
                  hideOnSinglePage: true,
                  responsive: true,
                }}
              />
            );
          },
          // rowExpandable: (value) => value.name !== 'Not Expandable',
          onExpand: (isExpand, { address }) => {
            if (isExpand) {
              setMapLoadingErrErc20({
                ...mapLoading,
                [address]: true,
              });
              props.fetchAdminBalancesAction({ address }, (balances) => {
                setMapLoadingErrErc20({
                  ...mapLoading,
                  [address]: false,
                });
                setMapErrErc20Arr({
                  ...mapAddressArr,
                  [address]: balances,
                });
              });
            }
          },
        }}
      />

      <Modal title="Thêm ví admin" visible={visible} footer={null} onCancel={() => { setVisible(false); }}>
        <Form labelCol={{ span: 6 }}>
          <Form.Item label="Nhãn" labelAlign="left">
            <Input type="text" name="label" onChange={handleChangeInput} />
          </Form.Item>
          <Form.Item label="Khóa bí mật" labelAlign="left">
            <Input
              type="text"
              name="private_key"
              onChange={handleChangeInput}
            />
          </Form.Item>
          <Form.Item label="Pubkey" labelAlign="left">
            <Input type="text" name="pubkey" onChange={handleChangeInput} />
          </Form.Item>
          <Form.Item>
            <Row justify="end">
              <Col span={3}>
                <Button type="primary" onClick={handleCancel}>
                  Hủy
                </Button>
              </Col>
              <Col>
                <DisplayControl permission_link_screen={consts.AUTH.MANAGER__ADD_WALLET} action={consts.CONTROLS.POST}>
                  <Button type="primary" onClick={handleOk}>
                    Xác nhận
                  </Button>
                </DisplayControl>

              </Col>
            </Row>
          </Form.Item>
        </Form>
      </Modal>

      <Modal
        title="Chuyển tiền trong sàn"
        visible={transferVisible}
        okText="Xác nhận"
        cancelText="Hủy bỏ"
        onOk={handleTransfer}
        onCancel={handleCloseTransfer}
        footer={null}
      >
        <Form labelCol={{ span: 6 }}>
          <Form.Item label="Nhãn" labelAlign="left">
            <Select
              defaultValue="BTC"
              name="coin"
              style={{
                width: 130,
                marginRight: 14,
              }}
              onChange={handleOnChangeCoin}
            >
              <Select.Option value="BTC">Bitcoin</Select.Option>
              <Select.Option value="ETH">Ethereum</Select.Option>
              <Select.Option value="ERC20">ERC20</Select.Option>
              <Select.Option value="TOMO">TOMO</Select.Option>
              <Select.Option value="TOMO_ERC20">TOMO ERC20</Select.Option>
            </Select>
          </Form.Item>
          <Form.Item label="Tới địa chỉ" labelAlign="left">
            <Input
              type="text"
              name="address"
              onChange={handleChangeInputTransfer}
            />
          </Form.Item>
          <Form.Item label="Tốc độ" labelAlign="left">
            <Radio.Group onChange={onChangeGas} value={paramsTransfer.gas}>
              <Radio.Button value="AVERAGE">Trung bình</Radio.Button>
              <Radio.Button value="FAST">Nhanh</Radio.Button>
              <Radio.Button value="FASTEST">Siêu nhanh</Radio.Button>
            </Radio.Group>
          </Form.Item>
          <Form.Item>
            <Row justify="end">
              <Col span={4}>
                <Button type="primary" onClick={handleCloseTransfer}>
                  Hủy
                </Button>
              </Col>
              <Col>
                <DisplayControl
                  permission_link_screen={[
                    { permission: consts.AUTH.MANAGER__MIGRATE_BTC__aDDRESS, action: consts.CONTROLS.POST },
                    { permission: consts.AUTH.MANAGER__MIGRATE_ERC20, action: consts.CONTROLS.POST },
                    { permission: consts.AUTH.MANAGER__MIGRATE_ETH, action: consts.CONTROLS.POST },
                  ]}
                >
                  <Button
                    type="primary"
                    htmlType="submit"
                    style={{ width: '84px' }}
                    // disabled={this.state.isLoadingSave}
                    icon={(
                      <Loadingsvg
                        name="bars"
                        hidden={!isLoadingSubmit}
                        size={25}
                      />
                    )}
                    onClick={handleCancelModelTranfer}
                  >
                    {isLoadingSubmit === false ? 'Xác nhận' : ''}
                  </Button>
                </DisplayControl>
              </Col>
            </Row>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
}

export default AdminWalletBalance;
